import React, { useEffect, useState } from "react"
import settingsStore from "../../stores/settingsStore"
import botStore from "../../stores/botStore"
import { ConfigProvider, Modal, theme } from "antd"
import { DeleteOutlined } from "@ant-design/icons"
import submitHandler from "../../services/submitHandler"

function calculateBannerPrice(variables, settings, expiresInDays) {
    const keyToPriceMap = new Map(settings.map((s) => [s.name, s.price]))

    let calculatedPrice = 0

    let calculationDescLines = []

    for (let variable of variables) {
        const variableMonthPrice = keyToPriceMap.get(variable.key) || 0

        const variablePriceTillExpire = Math.floor((variableMonthPrice * 30) / expiresInDays)

        calculationDescLines.push({
            type: "add",
            text: `مقدار ${variablePriceTillExpire} به حساب شما بابت متغیر ${variable.key} اضافه میشود`,
            price: variablePriceTillExpire,
        })

        calculatedPrice += variablePriceTillExpire
    }

    return { calculatedPrice, calculationDescLines }
}

const DeleteModal = ({ banner, isOpen, setIsOpen }) => {
    const [calculation, setCalculation] = useState(0)

    const settings = settingsStore((state) => state.settings)
    const bot = botStore((state) => state.bot)

    const toggleModal = () => setIsOpen(!isOpen)

    useEffect(() => {
        if (isOpen) {
            const diff = calculateBannerPrice(banner.variables, settings, bot?.expiresInDays)

            setCalculation(diff)
        }
    }, [isOpen])

    return (
        <>
            <ConfigProvider direction="rtl" theme={{ algorithm: theme.darkAlgorithm }}>
                <Modal
                    title="حذف بنر"
                    open={isOpen}
                    onCancel={toggleModal}
                    onOk={() => {
                        toggleModal()
                        submitHandler.delBanner(banner.id)
                    }}
                    okText={"حذف"}
                    cancelText={"بیخیال!"}
                    okType="danger"
                    okButtonProps={{ type: "primary" }}
                    footer={(_, { OkBtn, CancelBtn }) => (
                        <>
                            <div className="flex justify-between mx-2">
                                <div>
                                    مجموع: {calculation?.calculatedPrice?.toLocaleString("en-US")}{" "}
                                    تومان
                                </div>
                                <div className="flex gap-2">
                                    <CancelBtn />
                                    <OkBtn />
                                </div>
                            </div>
                        </>
                    )}
                >
                    <>
                        <div>
                            تعداد روز باقیمانده از بات بنر داینامیک شما: {bot?.expiresInDays} روز
                        </div>
                        <div className="bg-stone-800 mt-5 p-2 border-sky-500 border-2 rounded-md">
                            {calculation &&
                                calculation.calculationDescLines.map(({ type, text }, index) => (
                                    <div key={index} className="text-green-500">
                                        {text}
                                    </div>
                                ))}
                        </div>
                    </>
                </Modal>
            </ConfigProvider>
        </>
    )
}

export default DeleteModal
